<div style="padding: 2rem;">

  <!-- Page header -->
  <div style="margin-bottom: 1.75rem;">
    <h1 style="font-size: 1.5rem; font-weight: 700; color: #1e293b; margin: 0 0 0.25rem;">
      Boostages
    </h1>
    <p style="font-size: 0.875rem; color: #64748b; margin: 0;">Gestion des boostages</p>
  </div>

  <!-- Main card -->
  <div class="afri-card">

    <!-- Card header: actions + count -->
    <div class="afri-card-header">
      <div class="flex items-center gap-2 flex-wrap" *ngIf="buttonsPermission">
        <button *ngIf="buttonsPermission.add" (click)="add(addContent)" class="btn-afri-primary">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
          </svg>
          Ajouter
        </button>
        <button *ngIf="buttonsPermission.show" (click)="show(showContent)" class="btn-afri-outline">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
          </svg>
          Consulter
        </button>
        <button *ngIf="buttonsPermission.edit" (click)="edit(editContent)" class="btn-afri-outline" style="color: #d97706; border-color: #fcd34d;">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
          </svg>
          Éditer
        </button>
        <button *ngIf="buttonsPermission.delete" (click)="delete()" class="btn-afri-danger">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
          </svg>
          Supprimer
        </button>
      </div>
      <div class="flex items-center gap-2" style="font-size: 0.875rem; color: #64748b;">
        <span style="font-weight: 700; color: #1e293b; font-size: 1rem;">{{ data!.length }}</span>
        élément(s)
        <app-loading [isVisible]="loading2"></app-loading>
      </div>
    </div>

    <!-- Table -->
    <div style="overflow-x: auto;">
      <table class="afri-table">
        <thead>
          <tr>
            <th style="width: 52px; padding-left: 1.5rem;">#</th>
            <th>Nom</th>
            <th>Montant</th>
            <th>Type</th>
            <th>Durée</th>
            <th>Description</th>
            <th>Pays</th>
            <th>Ajouté par</th>
            <th>Modifié par</th>
            <th>Ajouté le</th>
            <th>Modifié le</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let d of data | paginate: {
                id: 'ngxP1',
                itemsPerPage: pg.pageSize,
                currentPage: pg.p,
                totalItems: pg.total
              } | sampleSearch:search_text"
              [style.background]="selected_data?.id === d.id ? '#f0f4ff' : ''">
            <td style="padding-left: 1.5rem;">
              <input (click)="checked(d)" type="radio" name="selectRow"
                     style="width: 16px; height: 16px; accent-color: #2E3190; cursor: pointer;">
            </td>
            <td>{{d.name}}</td>
            <td>{{d.amount}}</td>
            <td>{{d.type}}</td>
            <td>{{d.duration}}</td>
            <td>{{d.description}}</td>
            <td>{{d.country?.name}}</td>
            <td>{{d.creator?.lastname}} {{d.creator?.firstname}}</td>
            <td>{{d.updator?.lastname}} {{d.updator?.firstname}}</td>
            <td>{{d.created_at | date:"dd/MM/yyyy hh:mm:ss"}}</td>
            <td>{{d.updated_at | date:"dd/MM/yyyy hh:mm:ss"}}</td>
          </tr>

          <tr *ngIf="data.length === 0 && !loading2">
            <td colspan="11" style="padding: 4rem 1.25rem; text-align: center;">
              <div style="display: flex; flex-direction: column; align-items: center; gap: 0.75rem; color: #94a3b8;">
                <svg class="w-12 h-12" style="color: #e2e8f0;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                </svg>
                <p style="margin: 0; font-weight: 500;">Aucun élément trouvé</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div style="padding: 0.5rem 1.5rem 1.25rem;">
      <pagination-controls
        id="ngxP1"
        (pageChange)="getPage($event)"
        [maxSize]="9"
        [directionLinks]="true"
        [autoHide]="true"
        [responsive]="true"
        [previousLabel]="'Précédent'"
        [nextLabel]="'Suivant'">
      </pagination-controls>
    </div>

  </div><!-- end card -->
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
  <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">Enregistrer un plan</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="afri-label">Nom du plan <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="name" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Description <span class="text-danger ml-2">(*)</span></label>
          <textarea name="description" class="afri-input" ngModel></textarea>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Type <span class="text-danger ml-2">(*)</span></label>
          <select class="afri-input" ngModel name="type">
            <option value="article">Article</option>
            <option value="store">Boutique/Restaurant</option>
          </select>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Montant du plan <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="amount" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">La durée du plan <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="duration" class="afri-input" ngModel>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Code du pays <span class="text-danger ml-2">(*)</span></label>
          <select name="country_id" class="afri-input" ngModel>
            <option *ngFor="let c of countries" [value]="c.id">{{c.name}}</option>
          </select>
        </div>
      </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn-afri-primary" [disabled]="addForm.invalid">Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
  </div>
</form>
</ng-template>

<ng-template #editContent let-c="close" let-d="dismiss">
  <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">Modifier un plan</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="afri-label">Nom du plan <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="name" class="afri-input" [(ngModel)]="selected_data.name">
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Description <span class="text-danger ml-2">(*)</span></label>
          <textarea name="description" class="afri-input" [(ngModel)]="selected_data.description"></textarea>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Type <span class="text-danger ml-2">(*)</span></label>
          <select class="afri-input" [(ngModel)]="selected_data.type" name="type">
            <option value="article">Article</option>
            <option value="store">Boutique/Restaurant</option>
          </select>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Montant du plan <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="amount" class="afri-input" [(ngModel)]="selected_data.amount">
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">La durée du plan <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="duration" class="afri-input" [(ngModel)]="selected_data.duration">
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Code du pays <span class="text-danger ml-2">(*)</span></label>
          <select name="country_id" class="afri-input" [(ngModel)]="selected_data.country_id">
            <option *ngFor="let c of countries" [value]="c.id">{{c.name}}</option>
          </select>
        </div>
      </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn-afri-primary" [disabled]="editForm.invalid">Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
  </div>
</form>
</ng-template>

<ng-template #showContent let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Détails des informations</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="table-responsive table-card">
      <table class="table table-borderless align-middle mb-0">
        <tbody></tbody>
      </table>
    </div>
  </div>
</ng-template>
